import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Collapse, Row } from 'reactstrap';
import { kebabCase } from 'lodash';
import Icon from '../common/containers/icon';
import HeaderBar from './components/headerBar';
import Label from './components/label';
import entityComposition from '../common/classes/entityComposition';
import { labelSelector, styleSelector } from './selectors';
const Container = ({
  formatType,
  className: _className = '',
  collapsible: _collapsible = false,
  label: _label = null,
  startOpen: _startOpen = false,
  children: _children = null,
  style: _style = null
}) => {
  const [open, setOpen] = useState(_startOpen);
  const toggle = () => setOpen(!open);
  const testid = `container-${kebabCase(_label || '')}`;
  if (_collapsible) {
    const collapseStyle = {
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
      padding: '10px',
      position: 'relative',
      top: '0px'
    };
    const glyph = open ? 'caret-down fa-2x' : 'caret-right fa-2x';
    return /*#__PURE__*/React.createElement(Col, {
      className: "collapsible-header container",
      "data-testid": testid,
      style: _style
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: toggle,
      onKeyPress: toggle,
      style: {
        width: '100%'
      },
      color: "link",
      className: "t-cheader tqc-control"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'left',
        width: '30px'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      style: {
        position: 'relative',
        top: 10
      },
      glyph: glyph
    })), /*#__PURE__*/React.createElement("div", {
      style: collapseStyle
    }, /*#__PURE__*/React.createElement("h3", {
      className: `${_className}-${open ? 'open' : 'closed'}`
    }, _label))), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: open
    }, _children));
  }
  // for v1 subsection
  if (formatType === 'subsection') {
    // console.log(`value ${JSON.stringify(label, null, 2)}`);
    return /*#__PURE__*/React.createElement(Col, {
      "data-testid": testid,
      className: `container t-subsection-${kebabCase(_label)}`,
      style: _style
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(HeaderBar, {
      className: "col-md-12",
      value: _label
    }), _children));
  }
  return /*#__PURE__*/React.createElement(Col, {
    className: testid,
    "data-testid": testid,
    style: _style
  }, _label !== undefined ? /*#__PURE__*/React.createElement(Label, {
    value: _label
  }) : null, /*#__PURE__*/React.createElement(Row, null, _children));
};
Container.propTypes = {
  className: PropTypes.string,
  formatType: PropTypes.string.isRequired,
  children: PropTypes.node,
  collapsible: PropTypes.bool,
  startOpen: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.shape({})
};
export { Container as UncomposedContainer };
export default entityComposition(Container, [], {
  label: labelSelector,
  style: styleSelector
});